<template>
  <b-navbar
    :class="[
      'header',
      {
        'header--invert': inverted,
        'header--no-menu': hideMenu
      }
    ]"
  >
    <b-container>
      <b-navbar-nav>
        <b-nav-item link-classes="header__title" :to="{ name: 'home' }">
          <b-img-lazy
            alt="Logo"
            :src="
              inverted
                ? require('@/assets/images/logo-title-w.svg')
                : require('@/assets/images/logo-title-b.svg')
            "
            v-bind="logoProps"
            rounded
          ></b-img-lazy>
        </b-nav-item>
      </b-navbar-nav>

      <b-navbar-nav v-if="isAuthenticated" class="align-items-center">
        <b-nav-item :to="{ name: 'job.create-job-page' }">
          <b-button variant="outline-primary" class="post-btn"
            >Post a Tool</b-button
          >
        </b-nav-item>
        <b-nav-item-dropdown
          menu-class="header__nav"
          block
          right
          no-caret
          @show="show = true"
          @hide="show = false"
        >
          <template v-slot:button-content>
            <div class="header__avatar d-flex align-items-center">
              <b-avatar :src="userAvatar"></b-avatar>
              <h3 class="mr-3">{{ greetings }}</h3>
              <b-icon icon="caret-down-fill" aria-hidden="true"></b-icon>
            </div>
          </template>

          <b-dropdown-item :to="{ name: 'user.settings-page' }">
            <b-img
              class="icon"
              :src="require('@/assets/icons/user.svg')"
            ></b-img>
            <h5>My Account</h5>
          </b-dropdown-item>

          <b-dropdown-item :to="{ name: 'user.notifications-page' }">
            <b-img
              class="icon"
              :src="require('@/assets/icons/notifications.svg')"
            ></b-img>
            <h5>My Notifications</h5>
            <notification-count
              v-if="userUnreadCount"
              :value="userUnreadCount"
              class="float-right"
            ></notification-count>
          </b-dropdown-item>

          <b-dropdown-item :to="{ name: 'user.messages-page' }">
            <b-img
              class="icon"
              :src="require('@/assets/icons/messages.svg')"
            ></b-img>
            <h5>My Messages</h5>
          </b-dropdown-item>

          <b-dropdown-item :to="{ name: 'transaction.transactions-page' }">
            <b-img
              class="icon"
              :src="require('@/assets/icons/orders.svg')"
            ></b-img>
            <h5>My Transactions</h5>
          </b-dropdown-item>

          <b-dropdown-item :to="{ name: 'job.my-jobs-page' }">
            <b-img
              class="icon"
              :src="require('@/assets/icons/tools.svg')"
            ></b-img>
            <h5>My Tools</h5>
          </b-dropdown-item>

          <b-dropdown-item @click="onLoggingOut">
            <b-img
              class="icon"
              :src="require('@/assets/icons/sign-out.svg')"
            ></b-img>
            <h5>Sign-out</h5>
          </b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
      <b-navbar-nav v-else>
        <b-nav-item :to="{ name: 'auth.login-page' }">
          <b-button variant="outline-primary" class="sign-btn"
            >Sign In</b-button
          >
        </b-nav-item>
        <b-nav-item :to="{ name: 'auth.register-page' }">
          <b-button variant="primary" class="sign-btn">Register</b-button>
        </b-nav-item>
      </b-navbar-nav>
    </b-container>
  </b-navbar>
</template>
<script>
/**
 * ==================================================================================
 * Header section
 * ==================================================================================
 **/

import { mapState, mapGetters, mapActions } from 'vuex'
import NotificationCount from '@/components/NotificationCount'

export default {
  components: {
    NotificationCount
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      isAuthenticated: state => state.auth.isAuthenticated,
      device: state => state.device.deviceDetails
    }),
    ...mapGetters({
      userAvatar: 'auth/getUserThumbAvatar',
      userUnreadCount: 'auth/getUserUnreadCount'
    }),

    inverted() {
      return this.$route.meta && this.$route.meta.headerInvert
    },

    greetings() {
      return this.user
        ? 'Hello ' +
            (this.user.full_name ? this.user.full_name.split(' ')[0] : 'User')
        : ''
    },

    hideMenu() {
      if (this.$route.meta && this.$route.meta.hideHeaderMenu) return true
      return false
    }
  },

  data: function() {
    return {
      show: false,
      logoProps: {
        width: 150
      }
    }
  },

  methods: {
    ...mapActions({
      deleteDevice: 'device/deleteDevice',
      logout: 'auth/logout'
    }),

    async onLoggingOut() {
      if (this.device) {
        await this.deleteDevice()
      }

      await this.logout()
    }
  }
}
</script>
<style scoped lang="scss">
.header /deep/ {
  position: relative;
  padding-top: 15px;
  z-index: 1;

  button {
    height: 45px;
    min-height: inherit;
  }

  .post-btn {
    width: 130px;
    margin-right: 1rem;
  }

  .sign-btn {
    width: 100px;
  }

  .header__title {
    margin-left: -5px;
    padding: 0 0 10px 0;
  }

  .header__avatar {
    color: #212529;

    h3 {
      font-weight: 600;
      margin-bottom: 0;
    }

    .b-avatar {
      margin-right: 1rem;
    }

    > .b-icon {
      width: 12px;
    }
  }

  .header__nav {
    min-width: 500px;
    border-radius: 10px;
    top: 115%;
    border: none;
    padding: 2.25rem 0;
    box-shadow: var(--box-shadow);

    .dropdown-item {
      max-width: 430px;
      padding: 1.4rem 0;
      border-color: #00000008;

      h5 {
        display: inline;
        font-weight: 600;
        vertical-align: middle;
      }

      .badge {
        border-radius: 50%;
      }

      .b-icon,
      .icon {
        width: 24px;
        margin-right: 25px;
      }
    }
  }
}

.header.header--invert /deep/ {
  .header__avatar {
    color: #fff;
    .b-avatar {
      border: 2px solid #fff;
    }
  }
}

.header.header--no-menu /deep/ {
  .navbar-nav:not(:first-child) {
    visibility: hidden;
    opacity: 0;
    user-select: none;
  }
}

@media (max-width: 600px) {
  .header /deep/ {
    padding: 0.5rem 0;

    .post-btn {
      width: auto;
      margin-right: 0.5rem;
    }

    .sign-btn {
      width: 80px;
    }

    .nav-link {
      padding-right: 0;
    }

    .header__title {
      margin-left: 0;
    }

    .header__avatar {
      h3 {
        display: none;
      }

      .b-avatar {
        margin-right: 0.5rem;
      }

      > .b-icon {
      }
    }

    .header__nav {
      position: fixed;
      display: block;
      top: initial;
      bottom: 0%;
      left: 0;
      width: 100%;
      border-radius: 0;
      visibility: hidden;
      opacity: 0;
      transition: opacity var(--anim-trans);
    }

    .header__nav.show {
      visibility: visible;
      opacity: 1;
    }
  }
}
</style>
